import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAttach = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#A5A5AA"
      d="M19.241 4.702a5.671 5.671 0 0 0-8.1 0l-6.945 7.054a4.209 4.209 0 0 0 0 5.879 4.047 4.047 0 0 0 5.786 0l6.366-6.467c.464-.47.72-1.097.72-1.763 0-.667-.256-1.293-.72-1.764a2.43 2.43 0 0 0-3.472 0L8.714 11.87a.84.84 0 0 0 0 1.176.81.81 0 0 0 1.157 0l4.162-4.23a.81.81 0 0 1 1.158 0 .84.84 0 0 1 0 1.177l-6.365 6.466a2.43 2.43 0 0 1-3.472 0 2.525 2.525 0 0 1 0-3.527l6.944-7.055a4.05 4.05 0 0 1 5.786 0 4.163 4.163 0 0 1 1.199 2.94c0 1.11-.426 2.154-1.199 2.94L11.14 18.81a.84.84 0 0 0 0 1.175.809.809 0 0 0 1.158 0l6.943-7.054a5.828 5.828 0 0 0 1.678-4.115 5.828 5.828 0 0 0-1.678-4.115Z"
    />
  </svg>
);
export default SvgAttach;
